// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Fym-","icon":"styles_icon__1B84V"};